import _slicedToArray from "/codebuild/output/src138556528/src/github.com/ModusCreateOrg/roundupcattle-realtime-auction/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var shallowEqual = require('shallowequal');

import { useState, useCallback } from 'react';
/**
 *
 * @param monitor The monitor to colelct state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

export function useCollector(monitor, collect, onUpdate) {
  var _useState = useState(function () {
    return collect(monitor);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = useCallback(function () {
    var nextValue = collect(monitor);

    if (!shallowEqual(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]);
  return [collected, updateCollected];
}